import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";
import axios from 'axios';

// Função para exibir Toast
const showToastify = (message) => {
  Toastify({
    text: message,
    duration: 4000,
    gravity: "top",
    position: "center",
    close: true,
    style: {
      background: "#AEFF00",
      color: "black",
      borderRadius: "999px",
      padding: "12px 24px",
      fontFamily: "inherit",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
    },
    className: "toastify-custom",
  }).showToast();
};

const formEmpresa = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const section = document.getElementById('atendimento-empresa');
    if (!section) return;

    const formElement = document.getElementById('form-atendimento-empresa');
    if (!formElement) return;

    const telefoneInput = document.getElementById('telefone');

    // Máscara de telefone
    telefoneInput?.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 0) value = '(' + value;
      if (value.length > 3) value = value.slice(0, 3) + ') ' + value.slice(3);
      if (value.length > 10) value = value.slice(0, 10) + '-' + value.slice(10, 14);
      if (value.length > 16) value = value.slice(0, 16);
      e.target.value = value;
    });


    const cnpjInput = document.getElementById('cnpj');

    cnpjInput?.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '').slice(0, 14);
      value = value.replace(/^(\d{2})(\d)/, '$1.$2');
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
      value = value.replace(/(\d{4})(\d)/, '$1-$2');
      e.target.value = value;
    });


    formElement.addEventListener("submit", (e) => {
      e.preventDefault();

      const nome_empresa = document.getElementById('nome')?.value.trim();
      const email = document.getElementById('email')?.value.trim();
      const telefone = telefoneInput?.value.trim();
      const cnpj = document.getElementById('cnpj')?.value.trim();
      const responsavel_empresa = document.getElementById('responsavel')?.value.trim();

      if (!nome_empresa || !email || !telefone || !cnpj || !responsavel_empresa) {
        showToastify("Preencha todos os campos obrigatórios.");
        return;
      }

      const telefoneValido = /^\(\d{2}\)\s*\d\s*\d{4}-\d{4}$/.test(telefone);
      const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!telefoneValido) {
        showToastify("Telefone inválido. Use o formato (99) 9 9999-9999.");
        return;
      }

      if (!emailValido) {
        showToastify("E-mail inválido.");
        return;
      }

      const form_data = {
        nome_empresa,
        email,
        telefone,
        cnpj,
        responsavel_empresa,
      };

      const btnSubmit = formElement.querySelector("button[type=submit]");
      if (btnSubmit) btnSubmit.disabled = true;

      axios.post("/formulario-empresa/", form_data)
  .then((response) => {
    if (response.status === 200 && response.data?.status === "200") {
      const message = response.data?.message || "Mensagem enviada com sucesso!";
      showToastify(message);
      formElement.reset();
    } else {
      const message = response.data?.message || "Houve um problema ao enviar o formulário.";
      showToastify(message);
    }
  })
  .catch((error) => {
    const message = error.response?.data?.message || "Erro ao enviar o formulário.";
    showToastify(message);
  })
  .finally(() => {
    if (btnSubmit) btnSubmit.disabled = false;
  });

    });
  });
};

export default formEmpresa;
